import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, ShieldCheckIcon, CreditCardIcon, ZapIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const CART_URL = 'https://italia.kitonline.shop/cart/44568283611271:1';
export function PricingCard() {
  return <section id="pricing" className="py-10 sm:py-14 px-4 relative scroll-mt-10" data-id="element-218">
      <div className="absolute inset-0 bg-brand-orange/15 blur-[150px] rounded-full max-w-3xl mx-auto" data-id="element-219" />

      <div className="max-w-md sm:max-w-lg mx-auto relative z-10" data-id="element-220">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-6" data-id="element-221">
          <p className="text-xs font-black uppercase tracking-widest text-brand-orange mb-3" data-id="element-222">
            L'offerta
          </p>
          <h2 className="text-3xl sm:text-4xl font-black text-brand-cream leading-tight" data-id="element-223">
            Metodo Economia Aziendale{' '}
            <span className="bg-gradient-to-r from-brand-orange via-brand-amber to-brand-gold bg-clip-text text-transparent" data-id="element-224">
              Pro™
            </span>
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="relative rounded-3xl p-[2px] bg-gradient-to-b from-brand-orange via-brand-amber to-brand-gold shadow-[0_0_60px_rgba(249,115,22,0.35)]" data-id="element-225">
          <div className="bg-gradient-to-b from-[#1a0f0a] to-[#0d0703] rounded-3xl relative overflow-hidden" data-id="element-226">
            <div className="absolute -top-20 left-1/2 -translate-x-1/2 w-72 h-72 bg-brand-orange/20 blur-[80px] rounded-full pointer-events-none" data-id="element-227" />

            <div className="flex justify-center pt-4 pb-1 relative z-10" data-id="element-228">
              <div className="bg-gradient-to-r from-brand-orange to-brand-amber text-white font-black px-5 py-1.5 rounded-full flex items-center gap-1.5 uppercase tracking-wide text-xs shadow-[0_0_20px_rgba(249,115,22,0.6)]" data-id="element-229">
                <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-230" />
                LA SCELTA PIÙ POPOLARE DEI DOCENTI ITE
              </div>
            </div>

            <div className="p-6 sm:p-8 relative z-10" data-id="element-231">
              <h3 className="text-base sm:text-lg font-black text-center text-brand-cream uppercase mb-6 leading-tight" data-id="element-232">
                Cosa ottieni · Valore reale
              </h3>

              <div className="space-y-0 mb-5" data-id="element-233">
                {[{
                label: '6 Volumi PDF Opera Omnia — 400+ pagine',
                price: '€120'
              }, {
                label: 'Soluzionari & Materiale LIM per ogni Volume',
                price: '€67'
              }, {
                label: 'Manuale Recupero & Inclusione DSA/BES',
                price: '€57'
              }, {
                label: '4 Bonus Strategici Esclusivi',
                price: '€198'
              }].map((item, i) => <div key={i} className="flex justify-between items-center border-b border-brand-orange/15 py-3 gap-3" data-id="element-234">
                    <span className="text-gray-200 font-medium text-sm sm:text-base" data-id="element-235">
                      {item.label}
                    </span>
                    <span className="text-gray-400 line-through text-sm sm:text-base shrink-0" data-id="element-236">
                      {item.price}
                    </span>
                  </div>)}
                <div className="flex justify-between items-center pt-4" data-id="element-237">
                  <span className="text-base sm:text-lg font-black text-brand-cream uppercase" data-id="element-238">
                    Valore reale totale:
                  </span>
                  <span className="text-xl sm:text-2xl font-black text-brand-danger line-through" data-id="element-239">
                    €442
                  </span>
                </div>
              </div>

              <div className="relative rounded-2xl p-[2px] bg-gradient-to-r from-brand-orange via-brand-gold to-brand-orange mb-5 shadow-[0_0_30px_rgba(249,115,22,0.5)]" data-id="element-240">
                <div className="bg-[#1a0a04] rounded-2xl p-5 text-center" data-id="element-241">
                  <p className="text-brand-orange font-black text-[11px] sm:text-sm mb-2 uppercase tracking-wide" data-id="element-242">
                    €442 · 95% OFF · Offerta Lancio
                  </p>
                  <div className="flex justify-center items-center gap-2 mb-1" data-id="element-243">
                    <span className="text-2xl" data-id="element-244">💥</span>
                    <span className="text-4xl sm:text-5xl font-black bg-gradient-to-r from-brand-orange via-brand-amber to-brand-gold bg-clip-text text-transparent" data-id="element-245">
                      €19,90
                    </span>
                    <span className="text-2xl" data-id="element-246">💥</span>
                  </div>
                  <p className="text-xs text-gray-300 mt-1 font-medium" data-id="element-247">
                    💳 Pagamento unico · ⚡ Accesso immediato
                  </p>
                </div>
              </div>

              <div className="flex justify-center mb-5" data-id="element-248">
                <div className="inline-flex items-center gap-2 border border-brand-orange/40 bg-brand-orange/10 px-4 py-1.5 rounded-full" data-id="element-249">
                  <ShieldCheckIcon className="w-4 h-4 text-brand-orange" data-id="element-250" />
                  <span className="text-xs font-bold text-brand-orange" data-id="element-251">
                    ⏰ Prezzo speciale di lancio — salirà a breve
                  </span>
                </div>
              </div>

              <CTAButton href={CART_URL} className="w-full mb-5" data-id="element-252">
                SÌ! VOGLIO IL METODO COMPLETO
              </CTAButton>

              <div className="flex flex-wrap justify-center items-center gap-x-3 gap-y-1 text-[11px] sm:text-xs text-gray-400 font-medium" data-id="element-253">
                <span className="flex items-center gap-1" data-id="element-254">
                  <ZapIcon className="w-3 h-3 text-brand-gold" data-id="element-255" /> Accesso
                  Immediato
                </span>
                <span className="text-gray-600" data-id="element-256">•</span>
                <span className="flex items-center gap-1" data-id="element-257">
                  <CreditCardIcon className="w-3 h-3 text-brand-gold" data-id="element-258" /> Un solo
                  Pagamento
                </span>
                <span className="text-gray-600" data-id="element-259">•</span>
                <span className="flex items-center gap-1" data-id="element-260">
                  <ShieldCheckIcon className="w-3 h-3 text-brand-gold" data-id="element-261" />{' '}
                  Garanzia 14 Giorni
                </span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}